module.exports = __webpack_public_path__ + "assets/939a04a044777f512544564aed180b41.mp4";